import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Traain", 
  description = "Traain delivers enterprise-grade AI-powered training, role-play simulations, and enablement intelligence. Build better teams faster with Navigator AI™.",
  keywords = "AI training platform, enterprise training, AI role-play, employee enablement, workforce training software, Navigator AI",
  canonical = "",
  ogImage = "https://customer-assets.emergentagent.com/job_eb2f4f45-f0b0-4ab8-9f8a-8d8ecdd9022a/artifacts/azmc02qg_image.png",
  ogType = "website"
}) => {
  const siteUrl = "https://traain.com";
  const fullTitle = title === "Traain" ? "Traain | AI-Powered Training & Enablement" : `${title} | Traain`;
  const canonicalUrl = canonical || `${siteUrl}${typeof window !== 'undefined' ? window.location.pathname : ''}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Traain" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="author" content="Traain" />
      <meta name="language" content="English" />
    </Helmet>
  );
};

export default SEO;
